<template>
    <div class="col-md-12 p-0 master-list-page branch-page">
         <div class="card list-hero">
            <div class="card-body hero-content">
                <div><span class="hero-eyebrow">Operational Coverage</span><h4>Branch Station</h4><p>Kelola cabang dan cakupan wilayah operasional.</p></div>
                <div class="hero-total"><i class="ti ti-location-pin"></i><div><strong>{{ data_model.total | formatPrice }}</strong><span>Branches</span></div></div>
            </div>
         </div>
         <div class="card modern-list-card">
            <div class="card-body modern-list-body">
                <div class="table-header modern-list-header">
                    <h5 >Master Data <br/> <small>Total Records : <b>{{ data_model.total | formatPrice }}</b></small></h5>
                    <div class="group-search pull-right modern-actions">
                        <a class="btn icon-action" title="Refresh data" @click="tableRefresh()" ><i class="ti ti-reload"></i></a>
                        <a class="btn icon-action" title="Buka pencarian" @click="isActiveSearch()" ><i :class="isEnableTools == false  ? 'ti ti-search' : 'ti ti-close'"></i></a>
                        <div class="select" v-if="isEnableTools" >
                            <select v-model="meta_data.skey" @change="meta_data.sval = ''">
                                <option value="">-- Choose Field --</option>
                                <option value="name">Branch Name</option>
                                <option value="description">Description</option>
                            </select>
                        </div>
                        <div class="group" v-if="isEnableTools">
                            <input type="date" v-model="meta_data.sval" v-if="meta_data.skey == 'created_at' || meta_data.skey == 'updated_at'"/>
                            <input type="text" v-model="meta_data.sval" placeholder="Enter Keyword ...." v-else/>
                            <a class="btn" @click="tableSearch()">
                                SEARCH DATA 
                            </a>
                        </div>  
                        <router-link :to="{ name: meta_url + '/store' }" class="btn btn-primary" v-if="$store.state.app.access.includes('insert')"><i class="ti ti-plus"></i> Create New</router-link>
                    </div>
                    <div class="group-filter modern-filters">
                         <div class="form-group mr-2">
                                <label class="text-secondary">Propinsi</label>
                                <select  class="form-control" v-model="meta_filter.id_provinces"  @change="fetchKota()" style="max-width:200px;">
                                    <option value="all">-- All Propinsi --</option>
                                    <option v-for="(items, idx) in model_province"  :key="idx" :value="items.id">{{ items.nama_provinsi }}</option>
                                </select>
                            </div>
                            <!--<div class="form-group" style="width:200px;">
                                <label class="text-secondary">Kota</label>
                                <select  class="form-control" v-model="meta_filter.id_regencies"  @change="tableQuery()">
                                    <option value="all">-- All Kota --</option>
                                    <option v-for="(items, idx) in model_kota"  :key="idx" :value="items.id">{{ items.nama_kota }}</option>
                                </select>
                            </div>-->
                        </div>
                    </div>
                </div>
                <div class="table-cover modern-table-wrapper">
                    <table class="table table-hover modern-table" style="width:1800px;">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th width="70" class="no-filter text-center"  v-if="JSON.parse($store.state.app.access).length > 1">Action</th>
                                <th :class="meta_data.okey == 'name' ? 'active' : ''" v-on:click="tableOrdering('name')">Branch Station Name</th>
                                <th :class="meta_data.okey == 'id_provinces' ? 'active' : ''" v-on:click="tableOrdering('id_provinces')">Propinsi</th>
                                <th :class="meta_data.okey == 'group_regencies' ? 'active' : ''" v-on:click="tableOrdering('group_regencies')">Kota/Kabupaten</th>
                                <th :class="meta_data.okey == 'description' ? 'active' : ''" v-on:click="tableOrdering('description')">Branch Description</th>
                                <th :class="meta_data.okey == 'created_at' ? 'active' : ''" v-on:click="tableOrdering('created_at')">Created Date</th>
                                <th :class="meta_data.okey == 'updated_at' ? 'active' : ''" v-on:click="tableOrdering('updated_at')">Updated Date</th>
                            </tr>
                        </thead>
                        <tbody v-if="data_model.total > 0">
                             <tr  v-for="(items, idx) in data_model.data" :key="idx">
                                <td>{{ idx + data_model.from }}</td>
                                 <td  v-if="JSON.parse($store.state.app.access).length > 1"> 
                                    <div class="tools">
                                        <a href="javascript:;">Tools</a>
                                        <ul>
                                            <li  v-if="$store.state.app.access.includes('update')">
                                                <a href="javascript:;" @click="tableUpdate(items.id)" ><i class="text-success ti ti-pencil"></i> Edit</a>
                                            </li>
                                            <li  v-if="$store.state.app.access.includes('delete')">
                                                <a href="javascript:;" @click="tableRemove(items.id)"><i class="text-danger ti ti-trash"></i> Remove</a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                                <td width="250"> {{ items.name }}</td>
                                <td width="150"> {{ items.nama_provinsi }}</td>
                                <td width="550"> 
                                    <div v-if="items.applying_regencies == 'selected-area'">
                                        <span class="btn btn-light m-1" v-for="(items_area, idx) in DataDecode(items.group_regencies)" :key="idx" >{{ items_area.name }} </span>
                                    </div>
                                    <div v-else>
                                        <span class="btn btn-light m-1">All Area Regencies</span>
                                    </div>
                                </td>
                                <td width="350"> {{ items.description }}</td>
                                <td>{{ items.created_at | moment("DD/MM/YYYY") }}</td>
                                <td>{{ items.updated_at | moment("DD/MM/YYYY") }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pagination modern-footer" >
                    <small class="info"><i class="ti ti-split-h"></i> Scroll horizontal to view data.</small>
                    <paginate
                    :page-count="parseInt(data_model.last_page)"
                    :click-handler="tableQuery"
                    :container-class="'pagination'"
                    :page-class="'page-item'" >
                    </paginate>
                </div>
        </div>
    </div>
</template>
<script>

    import { mapState } from 'vuex';
    import axios from 'axios';

    export default {
        data() 
        {
            return { 
                isEnableTools : false, 
                isEnableOrder : false,
                meta_url : 'branch',
                
                model_province : [],
                model_kota : [],
                meta_data :{ okey: 'id', oval:'desc', wkey : '', wval : '', skey : '', sval : ''},
                meta_filter :{  id_provinces : 'all', id_regencies : 'all', }

            }
        },
       
        computed: {
            ...mapState('crud', {
                data_model: state => state.data_model,
                msg_error: state => state.error,
            })
        },
        created()
        {
            this.tableQuery();
            this.fetchProvinces();
        },
        methods:
        {
            
            isActiveSearch()
            {
                this.isEnableTools =! this.isEnableTools;
                if(this.isEnableTools) this.meta_data.sval = '';
            },
            DataDecode(data)
            {
                if(data)
                return JSON.parse(data);
            },
            async fetchProvinces()
            {
                await axios.get("location/propinsi/data")
                .then((response) => {
                    this.model_province = response.data;
                    this.model_kota = [];
                })
                .catch((error => {
                    console.log(error.statusText)
                })).finally(() => {
                    this.$store.state.loading.status = false;
                });
            },
            async fetchKota()
            {
                this.meta_filter.id_regencies      = 'all'; 
                this.meta_filter.id_kecamatan = 'all'; 
                await axios.post("location/kota/data", { 
                    where : { key : 'provinsi_id', value : this.meta_filter.id_provinces } ,
                    order : { key : 'id', value : 'asc' },
                })
                .then((response) => {
                    this.model_kota = response.data;
                    this.tableQuery();
                })
                .catch((error => {
                })).finally(() => {
                    this.$store.state.loading.status = false;
                });
            },
            tableUpdate(id)
            {
                localStorage.setItem('QUERY_ID', id);
                this.$router.push({name : this.meta_url + '/update'});
            },
            tableSearch()
            {
                if(this.meta_data.skey == ''){
                    alert('🙏, Please choose target field');
                    return;
                }
                if(this.meta_data.sval == ''){
                    alert('🙏, Please enter the keyword');
                    return;
                }
                this.tableQuery();
            },
            tableOrdering(key)
            {
                this.isEnableOrder =! this.isEnableOrder;
                this.meta_data.okey = key;
                this.meta_data.oval = this.isEnableOrder ? 'ASC' : 'DESC';
                this.tableQuery(this.page);
            },
            tableQuery(pageNum)
            {
                this.page = pageNum;
                let data = { 
                    url: this.meta_url+'/data',
                    offset : this.page,
                    search: { key : this.meta_data.skey, value : this.meta_data.sval },
                    order: { key : this.meta_data.okey, value : this.meta_data.oval },
                    where : { key : this.meta_data.wkey, value : this.meta_data.wval },
                    filter : [
                        {key : 'id_provinces', val:this.meta_filter.id_provinces},
                        {key : 'id_regencies', val:this.meta_filter.id_regencies},
                    ]
                };

                this.$store.state.loading.msg = 'Processing Fetching Data...';
                this.$store.state.loading.status = true;
                this.$store.dispatch('crud/getData', data );
            },  
            tableRefresh()
            {
                this.meta_data.skey = '';
                this.meta_data.sval = '';
                this.tableQuery();
            },

            async tableRemove(id)
            {
                if( confirm( 'Are you sure want to remove this data ?' ) )
                { 
                    let data = { url: this.meta_url+'/destroy/'+id };
                    let res = await this.$store.dispatch('crud/deleteData', data );
                    if(res)
                    {
                        if( res.result == 'ok' ){
                            this.tableQuery();
                        }
                        if( res.result == 'false' ){
                            alert(res.msg);
                        }
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.master-list-page { padding-bottom: 30px; }
.list-hero { min-height: 150px; margin-bottom: 20px; color: #fff; overflow: hidden; border: 0; border-radius: 14px; background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%); box-shadow: 0 10px 25px rgba(45, 111, 145, .16); }
.hero-content { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 25px 28px; }
.hero-eyebrow { color: #a7f3d0; font-size: 11px; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase; }
.list-hero h4 { margin: 5px 0 6px; color: #fff; font-weight: 700; }
.list-hero p { margin: 0; color: rgba(255,255,255,.78); }
.hero-total { display: flex; align-items: center; min-width: 160px; padding: 12px 18px; border: 1px solid rgba(255,255,255,.22); border-radius: 12px; background: rgba(255,255,255,.12); }
.hero-total > i { margin-right: 13px; font-size: 26px; }
.hero-total strong, .hero-total span { display: block; }
.hero-total strong { font-size: 22px; line-height: 1.1; }
.hero-total span { margin-top: 2px; color: rgba(255,255,255,.75); font-size: 11px; }
.modern-list-card { overflow: visible; border: 0; border-radius: 12px; box-shadow: 0 4px 18px rgba(28, 45, 75, 0.07); }
.modern-list-body { padding: 24px 26px; }
.modern-list-header {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;
  gap: 20px; padding-bottom: 20px; border-bottom: 1px solid #edf0f4;
  h5 { margin: 0; color: #364152; font-weight: 700; }
  h5 small { display: inline-block; margin-top: 5px; color: #7a8492; font-weight: 400; }
}
.modern-actions { display: flex; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: 8px; }
.modern-actions .btn { min-height: 40px; border-radius: 8px; }
.modern-actions .icon-action { display: inline-flex; align-items: center; justify-content: center; width: 40px; padding: 0; color: #1769aa; background: #e8f4ff; }
.modern-actions .select select, .modern-actions .group input { min-height: 40px; border: 1px solid #dfe4ea; border-radius: 8px; }
.modern-filters { flex-basis: 100%; padding: 16px 0 0; background: #fbfcfe; }
.modern-filters .form-group { margin-bottom: 0; }
.modern-filters label { margin-bottom: 6px; font-size: 11px; font-weight: 700; text-transform: uppercase; }
.modern-table-wrapper { overflow-x: auto; margin-top: 16px; border: 1px solid #edf0f4; border-radius: 10px; }
.modern-table { margin: 0; }
.modern-table thead th { padding: 15px 13px; border-top: 0; border-bottom: 1px solid #dee4ea; color: #77808d; background: #fbfcfe; font-size: 11px; font-weight: 700; letter-spacing: .35px; text-transform: uppercase; white-space: nowrap; }
.modern-table tbody td { padding: 15px 13px; border-color: #edf0f4; color: #364152; vertical-align: middle; }
.modern-table tbody tr:hover { background: #f8fbff; }
.modern-table .tools { position: relative; }
.modern-table .tools > a { display: inline-flex; align-items: center; justify-content: center; min-width: 72px; padding: 7px 12px; border-radius: 18px; color: #1769aa; background: #e8f4ff; font-size: 11px; font-weight: 700; text-decoration: none; }
.modern-table .tools > a::after { margin-left: 7px; content: "\25BE"; font-size: 9px; }
.modern-table .tools ul { overflow: hidden; min-width: 150px; border: 1px solid #e5eaf0; border-radius: 9px; box-shadow: 0 10px 28px rgba(28, 45, 75, .15); }
.modern-table .tools li a { display: block; padding: 10px 13px; color: #495568; background: #fff; }
.modern-table .tools li a:hover { color: #1769aa; background: #f2f8ff; }
.modern-footer { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding-top: 18px; color: #7a8492; }
@media (max-width: 767px) {
  .hero-content { align-items: stretch; flex-direction: column; padding: 22px 20px; }
  .hero-total { margin-top: 4px; }
  .modern-list-body { padding: 18px 14px; }
  .modern-list-header, .modern-footer { align-items: stretch; flex-direction: column; }
  .modern-actions { justify-content: flex-start; width: 100%; }
  .modern-actions .select, .modern-actions .group, .modern-actions .select select, .modern-actions .group input { width: 100%; }
  .modern-filters .form-group { width: 100%; max-width: none; }
}
</style>
